
export const CombinationSettings = {
    allowed: /[^0-9A-Za-z ]*/g,
    largeCharPattern:/[^02-9A-HJ-Za-hj-z]*/g,
    smallCharPattern: /[^Ii1]*/g,
    spacePattern: /[^ ]*/g
}